import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useHistory } from "react-router-dom";
import { UserProfileDataSource } from "../../../services/apis/UserProfileDataSource";
import { CallbackService } from "../oauth/services/callbackService";
import Loader from "../../../shared/Loader";
import { getVerifyAccesstoken, useAuth } from "../../../shared/hooks/useAuth";
import { apiClient } from "../../../services/api";
import { SwAlert } from "../../../shared/commons/Sweetalert2Template/Sweetalert2Template";

const ReactSwal = withReactContent(
  Swal.mixin({
    buttonsStyling: false,
    customClass: {
      confirmButton: "btn btn-warning btn-lg",
      cancelButton: "btn btn-default btn-lg",
      actions: "text-center",
    },
  })
);

const PassAuthenToVerify = (props) => {
  const callbackService = new CallbackService();
  let history = useHistory();
  const { loginByTrustParams } = useAuth();

  useEffect(() => {
    setTimeout(async () => {
      await initail();
    }, 1000);
  }, []);

  const initail = async () => {
    console.log("initail..");
    const params = await callbackService.getParamsFromUrl(window.location.href);
    const paramsObj = await callbackService.reduceParams(params);

    let paramsVerify = {
      accesstoken: paramsObj.accesstoken,
      redirect_url: paramsObj.redirectPath,
      oauthtoken: paramsObj.oauthtoken,
    };

    try {
      await getVerifyAccesstoken(paramsVerify);

      loginByTrustParams({
        accesstoken: paramsObj.accesstoken, //  It is x-accesstoken.
        redirectPath: paramsObj.redirectPath,
        oauthtoken: paramsObj.oauthtoken,
        route_code: paramsObj.route_code,
      });
    } catch (e) {
      console.log("eeeee", e);
      history.push({
        pathname: process.env.REACT_APP_LOGIN_ROUTE,
      });
      // throw e
    }

    // await apiClient.post('/security/token/verify-accesstoken',
    //     paramsVerify
    // ).then(result => {
    //   if (result.data.data && result.data.status.code == "200") {
    //     loginByTrustParams({
    //       uid: paramsObj.uid,
    //       accesstoken: paramsObj.accesstoken,
    //       redirectPath: paramsObj.redirectPath
    //     });
    //   }
    // }).catch(error => {
    //   console.log("error loading data", error)
    //   SwAlert({
    //     icon: "error",
    //     title: props.messages.NFMSG__LOAD_DATA_ERROR,
    //     description: props.messages.NFMSG__PLZ_TRY_AGAIN,
    //     confirmButtonText: props.messages['common.cancel']
    //   })
    // })
  };

  return <Loader />;
};

export default PassAuthenToVerify;
